'use strict';

var react = require('react');
const useSrLabel = () => {
  const [srLabelVisibility, setSrLabelVisibility] = react.useState(false);
  react.useEffect(() => {
    setTimeout(() => setSrLabelVisibility(true), 30);
  }, []);
  return srLabelVisibility;
};
module.exports = useSrLabel;
